import React from "react"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import FTPServer from "../../../../components/Products/Software/Videos/video-avm-fritzfon-c4"
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'AVM Fritzphone C4',
  description: 'Use your Synology or QNAP NAS to manage all your cameras and their video recordings. Or add them to your home automation system.',
  image: '/images/Search/P_SearchThumb_Products.png'
};

// export default (props) => (

function AvmFritzfon(props) {
      return (
            
      <React.Fragment>
        <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
        <h1 id="introduction" style={{ marginTop: 0 }}>
          INSTAR IP Kamera in AVM Fritz!Fon FritzFon hinzufügen für LiveBild
        </h1>
        <FTPServer />
        <br />
        <br />
        <Footer
          previousTitle="Other Platforms"
          previousLink="/fr/Software/Other_Platforms/"
          nextTitle="AVM Fritzphone"
          nextLink="/fr/Software/Other_Platforms/AVM_Fritzphone/" />
      </React.Fragment>
  )
}

export default AvmFritzfon